import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import { withFormContext } from 'Containers/FormContextHandler';
import { calculateDaysDifference } from 'neuro-utils';
import * as React from 'react';

import type { IFormContext } from 'Containers/FormContextHandler';

const FirstVisitSleepApneaForm = ({
  editing,
  formData,
  fm,
}: IFormContext<IDocumentWithTypeV2<'sleepApneaFirstVisit'>>): React.JSX.Element => {
  const document = formData.document;
  return (
    <React.Fragment>
      <FormRow title="diagnosis.sleepApnea.sleepApneaFirstVisit.referralOrAcute">
        <InputHandler
          type="Radio"
          editing={!!editing}
          name="referralOrAcute"
          formData={formData}
          options={['referral', 'acute']}
          optionFormatter={(s: string | number): string => fm('diagnosis.sleepApnea.sleepApneaFirstVisit.opts.' + s)}
          dependentFieldsList={(): string[] => ['dateOfReferral', 'dateOfFirstVisit']}
        />
      </FormRow>
      {document.referralOrAcute === 'referral' && (
        <>
          <FormRow title="diagnosis.sleepApnea.sleepApneaFirstVisit.dateOfReferral">
            <InputHandler type="PartialDate" editing={!!editing} name="dateOfReferral" formData={formData} />
          </FormRow>
          <FormRow title="diagnosis.sleepApnea.sleepApneaFirstVisit.dateOfFirstVisit">
            <InputHandler type="PartialDate" editing={!!editing} name="dateOfFirstVisit" formData={formData} />
          </FormRow>
          <FormRow title="diagnosis.sleepApnea.sleepApneaFirstVisit.delayFromArrivalToFirstVisit">
            {document.dateOfReferral && document.dateOfFirstVisit
              ? calculateDaysDifference(document.dateOfReferral, document.dateOfFirstVisit) +
                ' ' +
                fm('diagnosis.sleepApnea.days')
              : '-'}
          </FormRow>
        </>
      )}
    </React.Fragment>
  );
};

export default withFormContext(FirstVisitSleepApneaForm);
